export const FILTER_IDS = {
  SITE: 'site',
  GROUP: 'group',
};

export enum ColumnIds {
  DESCRIPTION = 'description',
  REASON = 'reason',
  STATUS = 'status',
  RESOLUTION = 'resolution',
  ENABLED = 'enable',
  AVAILABILITY = 'AVAILABILITY',
  STATUS_COL = 'STATUS_COL',
  ROUTE = 'ROUTE',
}

export const EXCEL_COLUMNS = [
  'Description',
  'Reason',
  'Status',
  'Resolution',
  'Enabled',
];

export const COLUMN_TEXT = [
  'description',
  'reason',
  'status',
  'resolution',
  'enabled',
];

export const CONSTS = {
  HEADER: $localize`Building Scan Admin`,
  SELECT: $localize`Select`,
  SEARCH_TYPE: $localize`Search`,
  FILTERS: $localize`Filters`,
  APPLY: $localize`Apply`,
  CLEAR: $localize`Clear`,
  N_A: $localize`N/A`,
  SITE: $localize`Site`,
  GROUP: $localize`Group`,
  DESCRIPTION: $localize`Description`.toUpperCase(),
  REASON: $localize`Reason`.toUpperCase(),
  STATUS: $localize`Status`.toUpperCase(),
  RESOLUTION: $localize`Resolution`.toUpperCase(),
  ENABLED: $localize`ENABLED`,
  WARNING_MODAL: {
    ENABLE: {
      HEADER: $localize`Enable`,
      BODY: $localize`Are you sure you want to enable the following %s?`,
    },
    DISABLE: {
      HEADER: $localize`Disable`,
      BODY: $localize`Are you sure you want to disable the following %s?`,
    },
  },
};

export const EXCEL_FILE_NAME = 'building-scan-data';
